import SnapshotsSerializer from './base';

export default class Snapshot extends SnapshotsSerializer {
  normalize(modelClass, payload) {
    let defaults = {
      pdfs: [],
    };
    Object.assign(defaults, payload);
    Object.assign(payload, defaults);

    return super.normalize(...arguments);
  }
}
